export default {"src":"/_next/static/media/no-address-data.e9bc260d.svg","height":79,"width":94,"blurWidth":0,"blurHeight":0};